import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import NavBar from "./components/NavBar";

// NEW — Floating Ad (replaces Footer)
import FloatingAd from "./components/FloatingAd";

// Public pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Trails from "./pages/Trails";
import TrailDetail from "./pages/TrailDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/Verifyemail";
import ForgotPassword from "./pages/Forgotpassword";
import UsefulLinks from "./pages/UsefulLinks";

// Client pages
import Dashboard from "./pages/Dashboard";
import RequireAuth from "./auth/RequireAuth";
import StartTrail from "./pages/StartTrail";

// Admin pages
import RequireAdmin from "./admin/RequireAdmin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminHomepage from "./admin/AdminHomepage";
import AdminAdvertisers from "./admin/AdminAdvertisers";
import AdminAdvertiserModify from "./admin/AdminAdvertiserModify";
import AdminAdvertiserEdit from "./admin/AdminAdvertiserEdit";
import AdminImageManager from "./admin/AdminImageManager";
import WordsearchGenerator from "./admin/WordsearchGenerator";
import AdminUsers from "./admin/AdminUsers";
import UnverifiedUsers from './admin/UnverifiedUsers';
import SupportMessages from './admin/SupportMessages';

// Trails Editor pages
import TrailsEditorDashboard from "./pages/trailseditor/TrailsEditorDashboard";
import EditTrail from "./pages/trailseditor/EditTrail";
import AddTrail from "./pages/trailseditor/AddTrail";
import AdminClues from "./pages/trailseditor/AdminClues";
import AddClue from "./pages/trailseditor/AddClue";
import AdminEditClue from "./pages/trailseditor/AdminEditClue";



// Other pages
import LoggedOut from "./pages/LoggedOut";
import EmailVerificationHandler from "./pages/EmailVerificationHandler";
import ConfirmEmail from "./pages/ConfirmEmail";

export default function App() {
  const location = useLocation();

  // Do NOT show the floating ad on admin pages or trailseditor pages
  const hideAds = location.pathname.startsWith("/admin") || location.pathname.startsWith("/trailseditor");

  return (
    <>
      <NavBar />

      {/* FLOATING AD — only on public/client pages */}
      {!hideAds && <FloatingAd />}

      <div className="app-content">
        <Routes>
          
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/trails" element={<Trails />} />
          <Route path="/trails/:id" element={<TrailDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/logged-out" element={<LoggedOut />} />
          <Route path="/usefullinks" element={<UsefulLinks />} />
          <Route path="/email-verified" element={<EmailVerificationHandler />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />

          {/* User Dashboard */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />

          {/* Start Trail Page */}
          <Route
            path="/start-trail/:id"
            element={
              <RequireAuth>
                <StartTrail />
              </RequireAuth>
            }
          />

          {/* ==================== */}
          {/* ADMIN ROUTES         */}
          {/* ==================== */}
          
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/homepage"
            element={
              <RequireAdmin>
                <AdminHomepage />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/users"
            element={
              <RequireAdmin>
                <AdminUsers />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/advertisers"
            element={
              <RequireAdmin>
                <AdminAdvertisers />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/advertiser-edit/:id"
            element={
              <RequireAdmin>
                <AdminAdvertiserEdit />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/advertiser-modify/:id"
            element={
              <RequireAdmin>
                <AdminAdvertiserModify />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/images"
            element={
              <RequireAdmin>
                <AdminImageManager />
              </RequireAdmin>
            }
          />

          <Route
            path="/admin/wordsearch"
            element={
              <RequireAdmin>
                <WordsearchGenerator />
              </RequireAdmin>
            }
          />

          {/* ==================== */}
          {/* TRAILS EDITOR ROUTES */}
          {/* ==================== */}
          
          {/* Trails Editor Dashboard */}
          <Route
            path="/trailseditor"
            element={
              <RequireAdmin>
                <TrailsEditorDashboard />
              </RequireAdmin>
            }
          />

          {/* Add New Trail */}
          <Route
            path="/trailseditor/new"
            element={
              <RequireAdmin>
                <AddTrail />
              </RequireAdmin>
            }
          />

          {/* Edit Trail */}
          <Route
            path="/trailseditor/:id/edit"
            element={
              <RequireAdmin>
                <EditTrail />
              </RequireAdmin>
            }
          />

          {/* Trail Clues List */}
          <Route
            path="/trailseditor/:id/clues"
            element={
              <RequireAdmin>
                <AdminClues />
              </RequireAdmin>
            }
          />

          {/* Add New Clue */}
          <Route
            path="/trailseditor/:id/clues/new"
            element={
              <RequireAdmin>
                <AddClue />
              </RequireAdmin>
            }
          />

          {/* Edit Clue */}
          <Route
            path="/trailseditor/:id/clues/:clueId/edit"
            element={
              <RequireAdmin>
                <AdminEditClue />
              </RequireAdmin>
            }
          />
          <Route path="/admin/unverified-users" element={<UnverifiedUsers />} />
          <Route path="/admin/unverified-users" element={<UnverifiedUsers />} />
<Route path="/admin/support-messages" element={<SupportMessages />} />
          

        </Routes>
      </div>
    </>
  );
}